const styles = (theme) => ({
  textButton: {
    textTransform: 'unset !important',
    color: `${theme.palette.text.primary} !important`,
  },
  componentName: {
    fontWeight: 300,
    fontSize: '18px',
  },
  header: {
    marginBottom: '16px',
  },
  componentSkeleton: {
    borderRadius: '4px',
    background: `${theme.palette.divider} !important`,
    marginLeft: '32px',
    marginRight: '24px',
    display: 'inline-block',
  },
  headerSkeletonButton: {
    borderRadius: '4px',
  },
  componentDescriptionBox: {
    borderRadius: '8px',
    padding: '16px',
    color: theme.palette.text.secondary,
  },
  componentDescriptionTitle: {
    fontSize: '12px',
    lineHeight: '18px',
  },
  instruction: {
    padding: '16px',
    background: `${theme.palette.background.paper}!important`,
    borderRadius: '8px',
  },
  instructionInfo: {
    maxWidth: '100%!important',
    background: theme.palette.action.hover,
    padding: '16px',
    fontSize: '14px',
    display: 'flex',
    rowGap: 2,
  },
});

export default styles;
